// Method vocabularies for the filter UI.
//
// GENERATED by scripts/gen-methods.sh; rerun it rather than hand-editing:
//   inbound  : agw-api-v2/internal/api/oas/oas_operations_gen.go  (OperationName)
//   outbound : agw-requester-v2/constants/constants.go            (NDC methods)
//
// Two vocabularies, not interchangeable:
//
//   inbound_requests.method           'AirOrderAddSeats'  (ogen OperationName)
//   outbound_requests.provider_method 'OrderAddSeats'     (NDC method)
//
// The sessions filter matches the inbound one. The inbound list comes from the
// generated ogen constants, not the OpenAPI spec: the spec's operationId is
// camelCase ('airShopping') while the tracer records ogen's PascalCase
// ('AirShopping').

/** v2 API operations: the `method` on an inbound request. */
export const INBOUND_METHODS: readonly string[] = [
  'AgencyAgentList',
  'AgencyRemarkCreate',
  'AgencyRemarkDelete',
  'AgencyRemarkList',
  'AgencyRemarkRetrieve',
  'AgencyRemarkUpdate',
  'AirAgencyPreset',
  'AirAgencyRemarkTemplates',
  'AirOffer3DSSession',
  'AirOfferOptions',
  'AirOfferPaymentInfo',
  'AirOfferPrice',
  'AirOfferSeatAvailability',
  'AirOfferServiceList',
  'AirOrder3DSSession',
  'AirOrderAcceptDisruption',
  'AirOrderAddAndIssueSeats',
  'AirOrderAddAndIssueServices',
  'AirOrderAddSeats',
  'AirOrderAddServices',
  'AirOrderCancel',
  'AirOrderComments',
  'AirOrderCreate',
  'AirOrderCreateAndIssue',
  'AirOrderCreateTask',
  'AirOrderEmail',
  'AirOrderExport',
  'AirOrderFile',
  'AirOrderHistory',
  'AirOrderIssue',
  'AirOrderList',
  'AirOrderLog',
  'AirOrderLogs',
  'AirOrderMetas',
  'AirOrderNotifications',
  'AirOrderNotificationsSeen',
  'AirOrderPDF',
  'AirOrderPaymentInfo',
  'AirOrderRebook',
  'AirOrderRebookAndIssue',
  'AirOrderRefund',
  'AirOrderRefundQuote',
  'AirOrderRemarks',
  'AirOrderRemarksRetrieve',
  'AirOrderRemoveSeats',
  'AirOrderRemoveServices',
  'AirOrderReprice',
  'AirOrderRequote',
  'AirOrderReshopping',
  'AirOrderRetrieve',
  'AirOrderSeatAvailability',
  'AirOrderServiceList',
  'AirOrderSplit',
  'AirOrderUpdateAddress',
  'AirOrderUpdateDoB',
  'AirOrderUpdateFQTV',
  'AirOrderUpdateOSI',
  'AirOrderUpdatePaxDocs',
  'AirOrderUpdatePaxInfo',
  'AirOrderUpdateServiceFee',
  'AirOrderVoid',
  'AirOrderVoidCheck',
  'AirProvidersList',
  'AirShopping',
  'AirShoppingStreaming',
  'ProfileCompanyCreate',
  'ProfileCompanyDelete',
  'ProfileCompanyList',
  'ProfileCompanyRemarkCreate',
  'ProfileCompanyRemarkDelete',
  'ProfileCompanyRemarkList',
  'ProfileCompanyRemarkRetrieve',
  'ProfileCompanyRemarkUpdate',
  'ProfileCompanyRetrieve',
  'ProfileCompanyUpdate',
  'ProfileTravellerCreate',
  'ProfileTravellerDelete',
  'ProfileTravellerList',
  'ProfileTravellerRetrieve',
  'ProfileTravellerUpdate',
  'ProposalActivityAcknowledge',
  'ProposalActivityList',
  'ProposalApprove',
  'ProposalAssign',
  'ProposalCancel',
  'ProposalConfirm',
  'ProposalCreate',
  'ProposalHistory',
  'ProposalList',
  'ProposalMessage',
  'ProposalOptionDiscard',
  'ProposalOptionOffer',
  'ProposalOptionWithdraw',
  'ProposalRetrieve',
] as const;

/** NDC method names sent to airlines: the `provider_method` on a leg. */
export const PROVIDER_METHODS: readonly string[] = [
  'AirDocIssue',
  'AirShopping',
  'Login',
  'OfferPrice',
  'OrderAcceptDisruption',
  'OrderAddSeats',
  'OrderAddServices',
  'OrderCancel',
  'OrderChange',
  'OrderCreate',
  'OrderCreateAndIssue',
  'OrderIssue',
  'OrderRebook',
  'OrderRebookAndIssue',
  'OrderRefund',
  'OrderRemoveSeats',
  'OrderRemoveServices',
  'OrderReprice',
  'OrderReshop',
  'OrderReshopRefund',
  'OrderReshopReprice',
  'OrderReshopVoid',
  'OrderRetrieve',
  'OrderSeatAvailability',
  'OrderServiceList',
  'OrderSplit',
  'OrderUpdateAddress',
  'OrderUpdateDoB',
  'OrderUpdateFQTV',
  'OrderUpdateOSI',
  'OrderUpdatePaxDocs',
  'OrderUpdatePaxInfo',
  'OrderUpdateServiceFee',
  'OrderVoid',
  'PaymentInfo',
  'PreADIReshop',
  'SeatAvailability',
  'ServiceList',
] as const;
